import React from 'react';
import PropTypes from 'prop-types';
import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement
} from 'react-stripe-elements';
import { Field } from 'redux-form';
import InputGroup from '../../InputGroup';
import TwoGroup from '../../TwoGroup';
import cardHelper from 'creditcards/card';
import { copyFor } from '../../../copy/copy';
import { PaymentMethod } from '../../../utils/enums';

const parseExpDate = value => {
    const digitsOnly = value.replace(/\D/g, '');
    return digitsOnly == null || digitsOnly === '' ? null : digitsOnly.replace(/\D/g, '');
};

const setCarotPosition = ev => {
    setTimeout(() => {
        var target = ev.target;
        var value = target.value;
        target.selectionStart = target.selectionEnd = value.length;
    }, 50);
};

const formatExpDate = (value, unParsedPrevValue) => {
    let newValue = value;

    if (value && value.length > 1) {
        newValue = `${value.slice(0, 2)}`;
        if (value.length === 2 && unParsedPrevValue && unParsedPrevValue.endsWith(' / '))
            return newValue;

        newValue += ' / ' + value.slice(2);
    }

    if (newValue && newValue.length === 9) {
        return newValue.slice(0, 5) + newValue.slice(-2);
    }

    return newValue;
};

const CreditCardInput = props => (
    <Field
        name="cardNumber"
        component={InputGroup}
        customInput={props.customInput}
        normalize={props.customInput ? null : value => cardHelper.format(value)}
        parse={props.customInput ? null : value => cardHelper.parse(value)}
        type="tel"
        inputmode="numeric"
        label="Credit card number"
        placeholder="Credit Card Number"
        autocomplete="cc-number"
        onChange={props.customInput ? null : ev => setCarotPosition(ev)}
        onValidityChange={props.onValidityChange}
    />
);

CreditCardInput.propTypes = {
    customInput: PropTypes.func,
    onValidityChange: PropTypes.func
};

const CvvInput = props => (
    <Field
        name="cvv"
        component={InputGroup}
        customInput={props.customInput}
        type="tel"
        inputmode="numeric"
        label="CVV"
        autocomplete="cc-csc"
        placeholder="CVV"
        maxLength={4}
        onValidityChange={props.onValidityChange}
    />
);

CvvInput.propTypes = {
    customInput: PropTypes.func,
    onValidityChange: PropTypes.func
};

const ExpirationDateInput = props => (
    <Field
        name="expDate"
        component={InputGroup}
        customInput={props.customInput}
        label="Exp. Date"
        normalize={
            props.customInput
                ? null
                : (value, unParsedPrevValue) => formatExpDate(value, unParsedPrevValue)
        }
        parse={props.customInput ? null : value => parseExpDate(value)}
        onChange={ev => setCarotPosition(ev)}
        maxLength={7}
        placeholder="Exp. Date"
        type="tel"
        autocomplete="cc-exp"
        onValidityChange={props.onValidityChange}
    />
);

ExpirationDateInput.propTypes = {
    customInput: PropTypes.func,
    onValidityChange: PropTypes.func
};

const PostalCodeInput = () => (
    <Field
        name="postalCode"
        component={InputGroup}
        type="text"
        label={copyFor('formFields', 'postalCode')}
        placeholder={copyFor('placeholders', 'postalCode')}
        autocomplete="billing postal-code"
        maxLength={10}
    />
);

class OrgHunterCreditCardInputs extends React.Component {
    render() {
        var customStyle = { invalid: { color: '#333' } };
        return (
            <div>
                <CreditCardInput
                    customInput={CardNumberElement}
                    customInputStyle={customStyle}
                    onValidityChange={isValid =>
                        this.props.onOrgHunterCcValidityChange('cardNumber', isValid)
                    }
                />
                <TwoGroup>
                    <ExpirationDateInput
                        customInput={CardExpiryElement}
                        customInputStyle={customStyle}
                        onValidityChange={isValid =>
                            this.props.onOrgHunterCcValidityChange('expDate', isValid)
                        }
                    />
                    <CvvInput
                        customInput={CardCVCElement}
                        customInputStyle={customStyle}
                        onValidityChange={isValid =>
                            this.props.onOrgHunterCcValidityChange('cvv', isValid)
                        }
                    />
                    <PostalCodeInput />
                </TwoGroup>
            </div>
        );
    }
}

OrgHunterCreditCardInputs.propTypes = {
    onOrgHunterCcValidityChange: PropTypes.func
};

class RegularCreditCardInputs extends React.Component {
    render() {
        return (
            <div>
                <CreditCardInput />
                <TwoGroup>
                    <ExpirationDateInput />
                    <CvvInput />
                    <PostalCodeInput />
                </TwoGroup>
            </div>
        );
    }
}

class CreditCardInputs extends React.Component {
    render() {
        return this.props.paymentMethod === PaymentMethod.OrgHunter ? (
            <OrgHunterCreditCardInputs {...this.props} />
        ) : (
            <RegularCreditCardInputs />
        );
    }
}

CreditCardInputs.propTypes = {
    paymentMethod: PropTypes.string.isRequired,
    onValidityChange: PropTypes.func
};

export default CreditCardInputs;
